import { render, staticRenderFns } from "./ShiftConfig.vue?vue&type=template&id=15c6d196&scoped=true"
import script from "./ShiftConfig.vue?vue&type=script&lang=js"
export * from "./ShiftConfig.vue?vue&type=script&lang=js"
import style0 from "./ShiftConfig.vue?vue&type=style&index=0&id=15c6d196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c6d196",
  null
  
)

export default component.exports